export default __webpack_public_path__ + "static/media/tablePreview_2.69d0ef9f.png";